import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue';
import Loading from './components/ModalLoading.vue';
import { appIsLoading } from 'src/store/state';
import 'src/store/useSync';
import ModalConfirm from './components/ModalConfirm.vue';

type BeforeInstallPromptEvent = Event & {
  prompt: () => void;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const confirmInstall = ref(false);

let deferredPrompt: BeforeInstallPromptEvent | undefined;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  confirmInstall.value = true;
  deferredPrompt = e as BeforeInstallPromptEvent;
});

const onConfirmInstall = async () => {
  confirmInstall.value = false;
  if (deferredPrompt) {
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    deferredPrompt = undefined;
  }
};

const onCancelInstall = () => {
  deferredPrompt = undefined;
  confirmInstall.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalConfirm, {
      show: confirmInstall.value,
      title: "Instalação",
      message: "Que tal instalar o app?",
      description: "Instale esse app no seu dispositivo. Ele ficará disponível na sua tela inicial. Será mais fácil para usá-lo sempre que você precisar.",
      onConfirm: onConfirmInstall,
      onCancel: onCancelInstall
    }, null, 8, ["show"]),
    (_unref(appIsLoading))
      ? (_openBlock(), _createBlock(Loading, { key: 0 }))
      : _createCommentVNode("", true),
    (!confirmInstall.value)
      ? (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})